import { ChevronLeft, ChevronRight } from "lucide-react";

/** React port of Agenda's AppPagination.vue. */
export function Pagination({
  page,
  pages,
  totalItems,
  limit = 25,
  onPageChange,
  className = "",
}: {
  page: number;
  pages: number;
  totalItems?: number;
  limit?: number;
  onPageChange: (page: number) => void;
  className?: string;
}) {
  const total = totalItems ?? pages * limit;
  const numbers = (() => {
    if (pages <= 7) return Array.from({ length: pages }, (_, index) => index + 1);
    const values = new Set([1, pages]);
    for (let offset = -1; offset <= 1; offset += 1) {
      const value = page + offset;
      if (value > 1 && value < pages) values.add(value);
    }
    const sorted = [...values].sort((a, b) => a - b);
    return sorted.flatMap((value, index) => {
      const previous = sorted[index - 1];
      return index > 0 && previous !== undefined && value > previous + 1
        ? ["..." as const, value]
        : [value];
    });
  })();
  const from = total === 0 ? 0 : (page - 1) * limit + 1;
  const to = Math.min(page * limit, total);
  const summary = total === 0 ? "Nenhum item encontrado" : total === 1 ? "Mostrando 1 resultado" : `Mostrando ${from} - ${to} de ${total} resultados`;

  return (
    <nav className={`pagination-container ${className}`.trim()} aria-label="Paginação">
      <div className="summary-desktop"><span className="summary-text">{summary}</span></div>
      <div className="nav-desktop">
        <button className="btn-nav" aria-label="Página anterior" type="button" disabled={page <= 1} onClick={() => onPageChange(page - 1)}><ChevronLeft size={16} /><span>Anterior</span></button>
        <div className="page-numbers">
          {numbers.map((number, index) => number === "..." ? <span key={`dots-${index}`} className="dots">...</span> : <button key={number} type="button" onClick={() => onPageChange(number)} className={`btn-page ${number === page ? "active" : ""}`}>{number}</button>)}
        </div>
        <button className="btn-nav" aria-label="Próxima página" type="button" disabled={page >= pages} onClick={() => onPageChange(page + 1)}><span>Próximo</span><ChevronRight size={16} /></button>
      </div>
      <div className="nav-mobile">
        <button className="btn-nav" type="button" disabled={page <= 1} onClick={() => onPageChange(page - 1)}><ChevronLeft size={16} /></button>
        <span className="mobile-summary">Página {page} / {pages}</span>
        <button className="btn-nav" type="button" disabled={page >= pages} onClick={() => onPageChange(page + 1)}><ChevronRight size={16} /></button>
      </div>
    </nav>
  );
}
